import { DealScreenRow } from 'app/models/deal-screen-row'
import * as types from './types'

/**
 * The read's rows, with the generation the request started under: the
 * reducer drops them if a write has bumped it since (utils/generation.ts).
 */
export const getDealScreen = (rows: DealScreenRow[], generation?: number) => ({
  type: types.GET_DEAL_SCREEN,
  payload: { rows, generation },
})

/**
 * Flip a set of rows to a status the ledger has already accepted.
 *
 * A bulk submit / approve answers with which ids succeeded, and that is the
 * whole change — so the grid is updated from the answer rather than refetched.
 * PQS projects a command asynchronously, so a refetch fired straight after the
 * response can still be reading the old contracts.
 */
export const setDealScreenStatuses = (payload: {
  ids: string[]
  status: DealScreenRow['status']
}) => ({
  type: types.SET_DEAL_SCREEN_STATUSES,
  payload,
})

/**
 * A write happened that the rows cannot be patched for. The grid reloads once.
 */
export const invalidateDealScreen = () => ({
  type: types.INVALIDATE_DEAL_SCREEN,
  payload: null,
})

/**
 * The read failed. Clears `stale` so nothing retries forever on a persistent
 * failure; the thunk tells the user, and the next mount reloads.
 */
export const dealScreenLoadFailed = () => ({
  type: types.DEAL_SCREEN_LOAD_FAILED,
  payload: null,
})

export const startLoadingDealScreen = () => ({
  type: types.START_LOADING_DEAL_SCREEN,
  payload: null,
})

export const stopLoadingDealScreen = () => ({
  type: types.STOP_LOADING_DEAL_SCREEN,
  payload: null,
})
